<!-- Mobile alert (visible only on mobile) -->
<div class="d-block d-md-none px-3 pt-2" *ngIf="showAlert" style="position: fixed; top: 56px; left: 0; right: 0; z-index: 1050;">
  <div class="alert mb-0"
       [ngClass]="alertType === 'success' ? 'alert-success' : 'alert-danger'"
       role="alert">
    <strong>{{alertTitle}}</strong>
    <p class="mb-0 mt-1" style="white-space: pre-line;">{{alertMessage}}</p>
    <button type="button" class="btn-close" (click)="onAlertClosed()" aria-label="Close"></button>
  </div>
</div>

<!-- Mobile view (< 768px) -->
<app-mobile-manufacturing-view
  class="d-block d-md-none"
  [boms]="billOfMaterials"
  [orders]="factoryOrders"
  [ordersByStatus]="ordersByStatus"
  [products]="products"
  [productsWithBOMs]="productsWithBOMs"
  [rawMaterials]="rawMaterials"
  [uoms]="uoms"
  [statuses]="statuses"
  [totalOrders]="totalOrders"
  [totalPendingOrders]="totalPendingOrders"
  [totalCompletedTodayOrders]="totalCompletedTodayOrders"
  [userRole]="userRole ?? ''"
  [showInactiveBOMs]="showInactiveBOMs"
  [availableBudgets]="availableBudgets"
  [completedFactoryOrders]="completedFactoryOrders"
  [showSoldOrders]="showSoldOrders"
  (saveBom)="onMobileSaveBom($event)"
  (deleteBom)="onMobileDeleteBom($event)"
  (toggleBomActive)="toggleBomActiveStatus($event)"
  (saveFactoryOrder)="onMobileSaveFactoryOrder($event)"
  (updateOrderStatus)="onMobileUpdateOrderStatus($event)"
  (updateOrderProgress)="onMobileUpdateProgress($event)"
  (sellOrder)="onMobileSellOrder($event)"
  (toggleShowSoldOrders)="showSoldOrders = !showSoldOrders">
</app-mobile-manufacturing-view>

<!-- Desktop view (>= 768px) -->
<div class="container-fluid d-none d-md-block">
          <!-- Alert inside modal -->

          <div class="mb-3" *ngIf="showAlert">
            <div class="alert"
                 [ngClass]="alertType === 'success' ? 'alert-success' : 'alert-danger'"
                 role="alert">
              <h5 class="alert-heading">{{alertTitle}}</h5>
              <p class="mb-0" style="white-space: pre-line;">{{alertMessage}}</p>
              <button type="button" class="btn-close" (click)="onAlertClosed()" aria-label="Close"></button>
            </div>
          </div>
  <div class="welcome-section mb-4 fade-in">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Manufacturing Dashboard</h2>
        <h4 class="welcome-text">Production Workflows, BOM Management, and Factory Order Tracking</h4>
      </div>

      <div class="d-flex align-items-center gap-3">
        <button style="border: 1px solid #ccc; border-radius: 5px;"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          (click)="toggleTableLayout()"
          [title]="isTablesStacked ? 'Switch to side-by-side view' : 'Switch to stacked view'"
        >
          <i class="bi" [ngClass]="isTablesStacked ? 'bi-layout-three-columns' : 'bi-layout-split'"></i>
          <span>{{ isTablesStacked ? 'Stacked Tables' : 'Side by Side' }}</span>
        </button>

        <div class="text-end">
          <small class="text-muted d-block">Current User:</small>
          <h6 class="mb-0">{{fullName}}</h6>
          <small class="text-muted d-block">{{tenantName}}</small>
        </div>
      </div>
    </div>
  </div>
  <div class="dashboard-cards fade-in">
    <!-- Total Orders Card -->
    <div class="metric-card main">
      <div class="card-content">
        <div class="icon-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z" stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 7H15M9 11H15M9 15H13" stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Total Orders</p>
          <h2 class="metric-value">{{ totalOrders }}</h2>
        </div>
      </div>
    </div>

    <!-- Pending Orders Card -->
    <div class="metric-card warning">
      <div class="card-content">
        <div class="icon-container warning">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16H12.01M12 8V12M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#6C7A3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Pending Orders</p>
          <h2 class="metric-value">{{ totalPendingOrders }}</h2>
        </div>
      </div>
    </div>

    <!-- Completed Today Card -->
    <div class="metric-card success">
      <div class="card-content">
        <div class="icon-container success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10L11 12L15 8" stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Completed Today</p>
          <h2 class="metric-value">{{ totalCompletedTodayOrders }}</h2>
        </div>
      </div>
    </div>
  </div>



  <div [ngClass]="{ 'dashboard-cards': isTablesStacked, 'MainCards': !isTablesStacked }">
    <!-- Bill of Materials Card -->
    <div class="metric-card">
      <div class="d-flex justify-content-between align-items-center pb-3  chart-header-border" style="margin-bottom: 0;">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-coin"></i>
            </div>
            <h3 class="chart-title mb-0">Bill of Materials</h3>
            <app-tooltip *ngIf="!isLoading && !showAddFactoryOrderModal && !showAddModal && !showSellModal"  [tooltipId]="'BOM'" style="z-index: 10000;">
              <i icon class="bi bi-info-circle"></i>
              <div content>
                <h5>About This Section</h5>
                <p>
                  <strong>
                    A Bill of Materials (often called a BOM) is just a list of everything you need to make a product. Think of it like a recipe for a product.
                  </strong>
                </p>
              </div>
            </app-tooltip>
          </div>
          <div class="d-flex gap-2">
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button" class="btn btn-grey-gradient" (click)="showInactiveBOMs = !showInactiveBOMs">
              <i class="bi me-1" [class.bi-eye]="!showInactiveBOMs" [class.bi-eye-slash]="showInactiveBOMs"></i>
              {{ showInactiveBOMs ? 'Hide' : 'Show' }} Inactive
            </button>
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button" class="btn btn-teal-gradient" (click)="toggleAddModal()">
              <i class="bi bi-plus-lg me-1"></i> Add Bom
            </button>
          </div>
      </div>
      <div class="card-body">
          <div *ngIf="billOfMaterials.length === 0" class="empty-state p-4 text-center">
            <div class="empty-state-icon mb-3">
              <i class="bi bi-coin" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No BOMs Found</h5>
            <p class="text-muted mb-0">Add your first BOM to get started</p>
            <button class="btn btn-primary mt-3" (click)="toggleAddModal()">
              <i class="bi bi-plus-circle me-1"></i> Add BOM
            </button>
          </div>
          <div *ngIf="billOfMaterials.length > 0" class="table-wrapper">
            <table class="table table-hover align-middle mb-0" style="position: relative">
              <thead class="table-header" style="position: sticky; top: 0; z-index: 1000">
                <tr>
                  <th class="fw-bold">Product</th>


                  <th *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" class="fw-bold">Active</th>
                  <th *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" class="fw-bold">Actions</th>
                </tr>
              </thead>
              <tbody style="position: relative; z-index: 1">
                <ng-container *ngFor="let product of billOfMaterials">
                  <ng-container *ngIf="showInactiveBOMs || product.isActive">
                    <div *ngIf="billOfMaterials.length === 0" class="empty-state p-4 text-center">
                      <div class="empty-state-icon mb-3">
                        <i class="bi bi-bag-check" style="font-size: 2.5rem; color: #6c757d;"></i>
                      </div>
                      <h5 class="mb-2">No BOMs Found</h5>
                      <p class="text-muted mb-0">Add your first BOM to get started</p>
                      <button class="btn btn-primary mt-3" (click)="toggleAddModal()">
                        <i class="bi bi-plus-circle me-1"></i> Add BOM
                      </button>
                    </div>
                    <!-- Product Row -->
                    <tr class="cursor-pointer" (click)="toggleExpansion(product)">
                    <td class="fw-semibold">
                      <i class="bi ms-2" [ngClass]="{
                          'bi-chevron-down': !product.expanded,
                          'bi-chevron-up': product.expanded
                        }"></i>
                      {{ getProductName(product.finishedGoodItemID) }}
                    </td>

                    <td *ngIf="userRole === 'Admin User' || userRole === 'Factory User'">
                      <div class="form-check form-switch d-inline-block">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [checked]="product.isActive"
                          (change)="toggleBomActiveStatus(product)"
                          (click)="$event.stopPropagation()">
                      </div>
                    </td>

                    <td *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" class="text-nowrap">
                      <button class="btn btn-outline-primary btn-sm me-2"
                        (click)="editProduct(product); $event.stopPropagation()">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                    </td>
                    </tr>
                    <!-- Expandable Raw Materials Row -->

                    <tr class="fade-in" *ngIf="product.expanded">
                      <td colspan="4" style="padding: 12px 0;">
                        <div class="material-items-container">
                          <ng-container *ngFor="let rm of product.components">
                            <div class="material-item">
                              <div class="material-icon">
                                <i class="bi bi-box-seam"></i>
                              </div>
                              <span class="material-name">{{ getRawMaterialName(rm.rawMaterialItemID) }} - {{ getRawMaterialCategoryName(rm.rawMaterialItemID) }}</span>
                              <span class="badge quantity-badge">{{ rm.quantityRequired }} {{ getComponentUOMCode(rm) }}</span>
                            </div>
                          </ng-container>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>

          </div>
      </div>
    </div>

    <!-- Factory Orders Card -->
    <div class="metric-card">

      <div class="d-flex justify-content-between align-items-center pb-3  chart-header-border">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-building"></i>
            </div>
            <h3 class="chart-title mb-0">Customer Orders</h3>
            <app-tooltip *ngIf="!isLoading &&!showAddFactoryOrderModal && !showAddModal && !showSellModal" [tooltipId]="'CustomerOrders'" style="z-index: 10000;">
              <i icon class="bi bi-info-circle"></i>
              <div content>
                <h5>About This Section</h5>
                <p>
                  <strong>
                    A customer order is when a person or company asks to buy something from a business.  It’s like saying:  “I want to buy this product or service — please get it ready for me.”                  </strong>
                </p>
              </div>
            </app-tooltip>
          </div>
          <div class="d-flex gap-2">
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button" class="btn btn-grey-gradient" (click)="toggleShowCompletedOrders()">
              <i class="bi me-1" [class.bi-eye]="!showCompletedOrders" [class.bi-eye-slash]="showCompletedOrders"></i>
              {{ showCompletedOrders ? 'Hide' : 'Show' }} Completed
            </button>
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" class="btn btn-teal-gradient" (click)="toggleAddFactoryOrderModal()">
              <i class="bi bi-plus-lg me-2"></i>Add Order
          </button>
          </div>

      </div>
        <div class="card-body">
          <div class="table-wrapper">
            <div *ngIf="factoryOrders.length === 0" class="empty-state p-4 text-center">
              <div class="empty-state-icon mb-3">
                <i class="bi bi-coin" style="font-size: 2.5rem; color: #6c757d;"></i>
              </div>
              <h5 class="mb-2">No Customer Orders Found</h5>
              <p class="text-muted mb-0">Add your first Customer Order to get started</p>
              <button class="btn btn-primary mt-3" (click)="toggleAddFactoryOrderModal()">
                <i class="bi bi-plus-circle me-1"></i> Add Customer Order
              </button>
            </div>
            <table *ngIf="factoryOrders.length > 0" class="table table-hover align-middle">


              <thead class="table-header">
                <tr>
                  <th class="fw-bold">Order Number</th>
                  <th class="fw-bold">Product</th>
                  <th class="fw-bold">Status</th>
                  <th class="fw-bold">Quantity</th>
                  <th class="fw-bold">Created At</th>
                  <th *ngIf="showCompletedOrders" class="fw-bold">Completed On</th>
                </tr>
              </thead>
              <tbody>
            <tr *ngFor="let order of displayedFactoryOrders" class="fade-in">
              <div *ngIf="factoryOrders.length === 0" class="empty-state p-4 text-center">
                <div class="empty-state-icon mb-3">
                  <i class="bi bi-bag-check" style="font-size: 2.5rem; color: #6c757d;"></i>
                </div>
                <h5 class="mb-2">No Customer Orders Found</h5>
                <p class="text-muted mb-0">Add your first Customer Order to get started</p>
                <button class="btn btn-primary mt-3" (click)="toggleAddFactoryOrderModal()">
                  <i class="bi bi-plus-circle me-1"></i> Add Customer Order
                </button>
              </div>
              <td class="fw-semibold">{{ order.orderNumber }}</td>
              <td class="fw-semibold">{{ getProductName(order.finishedGoodItemID) }}</td>
              <td class="status-cell">
                <div class="position-relative d-inline-block">
                  <div class="status-dropdown" (click)="$event.stopPropagation()">
                    <select
                    class="badge status-badge" [ngClass]="{
                      'bg-success': order.status === 'Completed',
                      'bg-warning': order.status === 'In Progress',
                      'bg-danger': order.status === 'Pending',
                      'bg-info': order.status === 'Quality Check',
                      'bg-secondary': order.status === 'Sold'
                    }" (click)="$event.stopPropagation()"
                      [ngModel]="order.status"
                      (ngModelChange)="updateOrderStatus(order, $event)"
                      (click)="$event.stopPropagation()">
                      <option *ngFor="let status of WorkflowStatuses(order)" [value]="status" [selected]="status === order.status">
                        {{ status }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td>
                <span class="badge bg-primary-soft text-primary">
                  {{ order.quantityToProduce }}
                </span>
              </td>
              <td>{{ order.createdAt | date : "d MMM yyyy" }}</td>
              <td *ngIf="showCompletedOrders">
                {{
                order.actualEndDate === "0001-01-01T00:00:00"
                ? "N/A"
                : (order.actualEndDate | date : "d MMM yyyy")
                }}
              </td>
            </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
  </div>





  <div class="d-flex row align-items-stretch h-100 justify-content-center mt-2" style="margin-bottom: 1%">
    <div class="col-md-9 d-flex">
      <div class="metric-card">
        <div class="d-flex justify-content-between align-items-center pb-3  chart-header-border">
            <div class="d-flex align-items-center">
              <div class="chart-icon-container me-3">
                <i class="bi bi-bag-check"></i>
              </div>
              <h3 class="chart-title mb-0">Available Products</h3>
              <app-tooltip *ngIf="!isLoading &&!showAddFactoryOrderModal && !showAddModal && !showSellModal" [tooltipId]="'AvailableProducts'" style="z-index: 10000;">
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <h5>About This Section</h5>
                  <p>
                    <strong>
                      Available products are the items/services a business has ready for customers to buy right now.                     </strong>
                  </p>
                </div>
              </app-tooltip>
            </div>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-grey-gradient" (click)="showSoldOrders = !showSoldOrders">
                <i class="bi me-1" [class.bi-eye]="!showSoldOrders" [class.bi-eye-slash]="showSoldOrders"></i>
                {{ showSoldOrders ? 'Hide' : 'Show' }} Sold / Filters
              </button>
              <button type="button" class="btn btn-grey-gradient" (click)="showAllOrders()" *ngIf="showSoldOrders">
                {{ showingAllOrders ? 'Filter by Date' : 'Show All' }}
              </button>
              <!-- Date filter for SOLD orders only -->
              <div class="d-flex align-items-center gap-2" *ngIf="showSoldOrders && !showingAllOrders">
                <label for="dateFieldSelect" class="form-label mb-0">Date Field:</label>
                <select id="dateFieldSelect"
                        class="form-select form-select-sm"
                        style="width: 160px;"
                        [(ngModel)]="dateFilterType"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onDateFilterTypeChange($event)"
                        aria-label="Select date field to filter by">
                  <option value="created">Created On</option>
                  <option value="completed">Completed On</option>
                </select>

                <label for="availableProductsStartDate" class="form-label mb-0">From:</label>
                <input id="availableProductsStartDate"
                       type="date"
                       class="form-control form-control-sm"
                       style="width: 150px;"
                       [(ngModel)]="startDate"
                       [ngModelOptions]="{standalone: true}"
                       (change)="onDateRangeChange($event)"
                       aria-label="Select start date to filter available products" />

                <label for="availableProductsEndDate" class="form-label mb-0">To:</label>
                <input id="availableProductsEndDate"
                       type="date"
                       class="form-control form-control-sm"
                       style="width: 150px;"
                       [(ngModel)]="endDate"
                       [ngModelOptions]="{standalone: true}"
                       (change)="onDateRangeChange($event)"
                       aria-label="Select end date to filter available products" />

              </div>
            </div>
        </div>
        <div class="card-body">
            <div class="table-wrapper">
              <div *ngIf="completedFactoryOrders.length === 0" class="empty-state p-4 text-center">
                <div class="empty-state-icon mb-3">
                  <i class="bi bi-bag-check" style="font-size: 2.5rem; color: #6c757d;"></i>
                </div>
                <h5 class="mb-2">No completed orders available for consumption</h5>
                <p class="text-muted mb-0">Add & Complete your first order to get started</p>

              </div>
              <table *ngIf="completedFactoryOrders.length > 0" class="table table-hover align-middle mb-0" style="position: relative">
                <thead class="table-header" style="position: sticky; top: 0; z-index: 1000">
                  <tr>
                    <th class="fw-bold">Order Number</th>
                    <th class="fw-bold">Product</th>
                    <th class="fw-bold">Produced Qty</th>
                    <th class="fw-bold">Created on</th>
                    <th class="fw-bold">Completed on</th>
                    <th class="fw-bold">Actions</th>
                  </tr>
                </thead>
                <tbody style="position: relative; z-index: 1">
                  <ng-container>
                    <!-- Remove the outer *ngFor and keep only the inner one -->
                    <tr *ngFor="let order of completedFactoryOrders" class="fade-in">
                      <td class="fw-semibold">{{ order.orderNumber }}</td>
                      <td class="fw-semibold">{{ getProductName(order.finishedGoodItemID) }}</td>
                      <td>
                        <span class="badge bg-primary-soft text-primary">
                          {{ order.quantityToProduce }}
                          <span *ngIf="(order.quantitySold || 0) > 0">
                            ({{ order.quantitySold }} sold)
                          </span>
                        </span>
                      </td>
                      <td>{{ order.createdAt | date : "d MMM yyyy"  }}</td>
                      <td>{{ order.actualEndDate | date : "d MMM yyyy" }}</td>
                      <td class="text-end">
                        <div class="d-flex justify-content-end gap-2">
                          <div class="input-group input-group-sm" style="width: 150px;">
                            <input style="height: auto;"
                              type="number"
                              class="form-control form-control-sm"
                              [value]="order.quantityToProduce - (order.quantitySold || 0)"
                              min="1"
                              [max]="order.quantityToProduce - (order.quantitySold || 0)"
                              #qtyInput
                              [disabled]="order.status === 'Sold'"
                            >
                            <button
                              type="button"
                              class="btn btn-sm"
                              [class.btn-success]="order.status !== 'Sold'"
                              [class.btn-outline-secondary]="order.status === 'Sold'"
                              (click)="startPartialSale(order, qtyInput.valueAsNumber); showSellModal = true; "
                              [disabled]="loading || order.status === 'Sold'"
                            >
                              <i class="bi me-1" [class.bi-cart-check]="order.status !== 'Sold'" [class.bi-check2-all]="order.status === 'Sold'"></i>
                              <span *ngIf="!loading">
                                {{ order.status === 'Sold' ? 'Sold' : 'Sell' }}
                              </span>
                              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
                            </button>
                          </div>
                          <button
                            *ngIf="order.status !== 'Sold'"
                            type="button"
                            class="btn btn-sm btn-outline-success"
                            (click)="startPartialSale(order, order.quantityToProduce - (order.quantitySold || 0))"
                            [disabled]="loading"
                            title="Mark all remaining as sold"
                          >
                            <i class="bi bi-cart-check me-1"></i>
                            <span *ngIf="!loading">All</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="completedFactoryOrders.length === 0">

                      <!-- <td colspan="6" class="text-center py-4">
                        <div class="text-muted">No completed orders available for consumption</div>
                      </td> -->
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 d-flex  fade-in">
      <div class="w-100" style="border-radius: 5px">
        <div class="metric-card">
          <div *ngIf="factoryOrders.length === 0" class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-pie-chart"></i>
            </div>
            <h3 class="chart-title mb-0">Orders By Status</h3>

          </div>

          <div *ngIf="factoryOrders.length === 0" class="empty-state p-4 text-center">

            <div class="empty-state-icon mb-3">
              <i class="bi bi-pie-chart" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No Orders</h5>

          </div>
          <div *ngIf="factoryOrders.length > 0" class="card-body">
            <app-pie-chart
              [labels]="categoryLabels"
              [data]="categoryData"
              [title]="'Order By Status'"
              [colors]="['#FF6384', '#FFCD35', '#17A2B8', '#4DE270', '#6C757D']"
              [ItemsPerPage]="5">
            </app-pie-chart>
          </div>
      </div>
      </div>
    </div>
  </div>




  <div class="d-flex row align-items-stretch h-100 justify-content-center mt-4">
    <div>
      <div class="card shadow-sm p-3">
        <div  class="d-flex align-items-center" style="margin-bottom: 10px; border-bottom: 1px solid #dee2e6; padding: 10px 0;">
          <div class="chart-icon-container me-3">
            <i class="bi bi-kanban"></i>
          </div>
          <div class="flex-column">
            <h3 class="chart-title mb-0">Workflow Tracker</h3>
            <small *ngIf="showPendingWarning" class="text-muted" style="color: red !important;">  <i class="bi bi-info-circle"></i> Cannot move order back to Pending status once it has progressed beyond it.</small>
          </div>
        </div>

        <div *ngIf="factoryOrders.length === 0" class="empty-state p-4 text-center">
          <div class="empty-state-icon mb-3">
            <i class="bi bi-pie-chart" style="font-size: 2.5rem; color: #6c757d;"></i>
          </div>
          <h5 class="mb-2">No Orders</h5>

        </div>
        <div *ngIf="factoryOrders.length > 0" class="d-flex gap-3 overflow-auto">
          <div *ngFor="let status of WorkflowStatuses()" class="kanban-column card fade-in"
            [ngStyle]="{ 'border-color': getStatusColor(status) }">

            <div class="kanban-header">
              <div class="status-icon" [ngStyle]="{'background-color': getStatusColor(status)}">
                <i class="bi" [ngClass]="{
                  'bi-hourglass-split': status === 'Pending',
                  'bi-tools': status === 'In Progress',
                  'bi-check2-circle': status === 'Quality Check',
                  'bi-check2-all': status === 'Completed'
                }"></i>
              </div>
              <h3 class="mb-0">{{ status }}</h3>
            </div>
            <div class="card-body p-2">
              <div cdkDropList [id]="sanitize(status)" [cdkDropListData]="ordersByStatus[status]"
                [cdkDropListConnectedTo]="getSanitizedStatuses()" class="kanban-list"
                (cdkDropListDropped)="onDrop($event, status)">
                <div *ngFor="let order of ordersByStatus[status]" cdkDrag class="kanban-card card mb-2 p-2 bg-white"
                [ngStyle]="{ 'border-color': getStatusColor(status) }"
                [cdkDragDisabled]="isAdjustingSlider"
                >
                  <h6 class="mb-1">{{ getProductName(order.finishedGoodItemID) }}</h6>
                  <span class="d-flex flex-column gap-2">
                    <span class="badge bg-primary-soft text-primary">Qty: {{ order.quantityToProduce }}</span>

                    <div class="progress position-relative" style="height: 1rem; margin-top: 5px; margin-bottom: 5px">
                      <div class="progress-bar bg-primary" role="progressbar"
                        [style.width]="order.completionPercentage + '%'"
                        [attr.aria-valuenow]="order.completionPercentage" aria-valuemin="0" aria-valuemax="100"
                        style="transition: width 0.1s ease">
                        {{ order.completionPercentage }}%
                      </div>

                      <input type="range" class="position-absolute w-100 h-100 top-0 start-0"
                        [id]="'progressRange_' + order.productionOrderID" min="0" max="100"
                        [(ngModel)]="order.completionPercentage"
                        (input)="onProgressInput($event, order)"
                        (change)="updateProgress($event, order)"
                        (pointerdown)="isAdjustingSlider = true; $event.stopPropagation()"
                        (pointerup)="isAdjustingSlider = false; $event.stopPropagation()"
                        (pointercancel)="isAdjustingSlider = false; $event.stopPropagation()"
                        (mousedown)="isAdjustingSlider = true; $event.stopPropagation()"
                        (mouseup)="isAdjustingSlider = false; $event.stopPropagation()"
                        (touchstart)="isAdjustingSlider = true; $event.stopPropagation()"
                        (touchend)="isAdjustingSlider = false; $event.stopPropagation()"
                        (touchcancel)="isAdjustingSlider = false; $event.stopPropagation()"
                        style="
                          -webkit-appearance: none;
                          appearance: none;
                          background: transparent;
                          outline: none;
                          margin: 0;
                          opacity: 0;
                          z-index: 3;
                          cursor: grab;
                        " />

                      <div class="position-absolute" [style.left]="order.completionPercentage + '%'" style="
                        top: 50%;
                        transform: translate(-50%, -50%);
                        height: 1rem;
                        width: 1rem;
                        background-color: white;
                        border: 2px solid #007a8f;
                        border-radius: 50%;
                        z-index: 4;
                        pointer-events: none;
                        "></div>
                    </div>
                  </span>

                  <div class="d-flex justify-content-between align-items-center text-muted small"
                    style="margin-top: 1%">

                    <div class="d-flex align-items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                      <span>{{ order.createdAt | date : "d MMM yyyy"  }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



















<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showAddFactoryOrderModal"></div>

<!-- Modal -->
<div class="modal fade show" [class.d-block]="showAddFactoryOrderModal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">Create New Customer Order</h5>
        <button type="button" class="btn-close btn-close-white" (click)="toggleAddFactoryOrderModal()"></button>
      </div>

      <form [formGroup]="factoryOrderForm" (ngSubmit)="createFactoryOrder()">
        <div class="modal-body">
                <!-- Alert inside modal -->
                <div class="mb-3" *ngIf="showAlert">
                  <div class="alert"
                       [ngClass]="alertType === 'success' ? 'alert-success' : 'alert-danger'"
                       role="alert">
                    <h5 class="alert-heading">{{alertTitle}}</h5>
                    <p class="mb-0" style="white-space: pre-line;">{{alertMessage}}</p>
                    <button type="button" class="btn-close" (click)="onAlertClosed()" aria-label="Close"></button>
                  </div>
                </div>

          <div class="row form-section supplier-section mb-4 m-3">
            <div class="col-md-6">
              <label class="form-label">Product</label>
              <select class="form-select"
                      formControlName="finishedGoodItemID"
                      [class.is-invalid]="factoryOrderForm.get('finishedGoodItemID')?.invalid && factoryOrderForm.get('finishedGoodItemID')?.touched">
                <option value="" disabled>Select a product</option>
                <option *ngFor="let product of productsWithBOMs" [value]="product.itemID">{{ product.itemName }}</option>
              </select>
              <div class="form-text small text-muted">
                <i class="bi bi-info-circle me-1"></i> Only products with an active BOM are shown
              </div>
              <div class="invalid-feedback">Product is required</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Quantity</label>
              <input type="number" class="form-control" formControlName="quantityToProduce" min="1"
                     [class.is-invalid]="factoryOrderForm.get('quantityToProduce')?.invalid && factoryOrderForm.get('quantityToProduce')?.touched">
              <div class="invalid-feedback">Quantity must be at least 1</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Planned Start Date</label>
              <input type="date" class="form-control" formControlName="plannedStartDate"
                     [class.is-invalid]="factoryOrderForm.get('plannedStartDate')?.invalid && factoryOrderForm.get('plannedStartDate')?.touched">
              <div class="invalid-feedback">Start date is required</div>
            </div>

            <div class="col-md-6">
              <label class="form-label">Planned End Date</label>
              <input type="date" class="form-control" formControlName="plannedEndDate"
                     [class.is-invalid]="factoryOrderForm.get('plannedEndDate')?.invalid && factoryOrderForm.get('plannedEndDate')?.touched">
              <div class="invalid-feedback">End date is required</div>
            </div>

            <!-- <div class="col-12">
              <label class="form-label">Notes</label>
              <textarea class="form-control" formControlName="notes" rows="3"></textarea>
            </div> -->
          </div>
          <div class="col-12 mt-3">

            <app-budget-selector
              [totalCost]="productTotalCost * (factoryOrderForm.get('quantityToProduce')?.value || 1)"
              [availableBudgets]="availableBudgets"
              [productId]="factoryOrderForm.get('finishedGoodItemID')?.value"
              [productName]="getProductName(factoryOrderForm.get('finishedGoodItemID')?.value) || ''"
              (assignmentsChange)="onAssignmentsChange($event)"
              (assignmentsSave)="saveBudgetAssignments($event)"
            ></app-budget-selector>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-grey-gradient" (click)="toggleAddFactoryOrderModal()">Cancel</button>
          <button type="submit"
                  class="btn btn-teal-gradient"
                  [disabled]="factoryOrderForm.invalid || loading || !isBudgetAssignmentValid()"
                  >
            <ng-container *ngIf="!loading; else loadingTpl">
              <i class="bi bi-plus-circle me-2"></i> Create Order
            </ng-container>
            <ng-template #loadingTpl>
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
              Creating...
            </ng-template>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


  <!-- Bill of Materials Modal -->
  <div class="modal-backdrop fade show" *ngIf="showAddModal"></div>

  <div class="modal fade show d-block" *ngIf="showAddModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ isEditMode ? 'Edit Bill of Materials' : 'Add Bill of Materials' }}</h5>
          <button type="button" class="btn-close btn-close-white" (click)="toggleAddModal()"></button>
        </div>

        <form [formGroup]="billOfMaterialForm" (ngSubmit)="submitBOM()">
          <div class="modal-body">

            <div class="form-section supplier-section mb-4">
              <div class="row g-3">
                <div class="col-md-5">
                  <label class="form-label" for="bomProductBtn">Product</label>
                  <input type="hidden" formControlName="finishedGoodItemID" />
                  <!-- Read-only product when editing; dropdown when adding -->
                  <div *ngIf="isEditMode; else bomProductSelector" class="form-control-plaintext fw-semibold">
                    {{ getBomProductDisplay(billOfMaterialForm.get('finishedGoodItemID')?.value) || 'Selected product' }}
                  </div>

                  <ng-template #bomProductSelector>
                    <button
                      type="button"
                      id="bomProductBtn"
                      class="form-control text-start d-flex align-items-center justify-content-between mb-2"
                      [class.is-invalid]="billOfMaterialForm.get('finishedGoodItemID')?.invalid && billOfMaterialForm.get('finishedGoodItemID')?.touched"
                      #bomBtn
                      (mousedown)="onBomProductToggleMouseDown(bomBtn, $event)"
                      (click)="$event.stopPropagation()"
                      aria-haspopup="listbox"
                      [attr.aria-expanded]="bomProductDropdownOpen"
                      [attr.aria-controls]="'bomProductMenu'"
                    >
                      <span class="text-truncate">
                        {{ getBomProductDisplay(billOfMaterialForm.get('finishedGoodItemID')?.value) || 'Select Product' }}
                      </span>
                      <i class="bi ms-2" [ngClass]="{ 'bi-chevron-down': !bomProductDropdownOpen, 'bi-chevron-up': bomProductDropdownOpen }"></i>
                    </button>

                    <!-- Custom dropdown menu for products -->
                    <div
                      class="card shadow-sm mt-1"
                      [id]="'bomProductMenu'"
                      *ngIf="bomProductDropdownOpen"
                      role="listbox"
                      (mousedown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation()"
                      [ngStyle]="{
                        position: 'fixed',
                        zIndex: 2147483647,
                        top: (bomProductDropdownStyles && bomProductDropdownStyles.top) || '0',
                        left: (bomProductDropdownStyles && bomProductDropdownStyles.left) || '0',
                        width: bomProductDropdownStyles ? 'calc(' + bomProductDropdownStyles.width + ' + 15%)' : '100%'
                      }"
                      style="border-radius: .375rem; max-height: 260px; overflow: hidden; pointer-events: auto;"
                    >
                      <div class="p-2 border-bottom bg-white">
                        <input
                          type="text"
                          class="form-control form-control-sm rm-search-input"
                          placeholder="Search products..."
                          aria-label="Search products"
                          [(ngModel)]="bomProductSearchText"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onBomProductSearchChange()"
                          (keydown.escape)="bomProductDropdownOpen = false"
                          autofocus
                        />
                      </div>
                      <div class="list-group list-group-flush" style="max-height: 210px; overflow-y: auto;">
                        <button type="button" class="list-group-item list-group-item-action" (click)="selectBomProduct(null)">
                          Select Product
                        </button>
                        <button
                          type="button"
                          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                          *ngFor="let product of bomProductPaged"
                          (click)="selectBomProduct(product)"
                          role="option"
                          [attr.aria-selected]="billOfMaterialForm.get('finishedGoodItemID')?.value === product.itemID"
                        >
                          <span class="text-truncate">{{ product.itemName }}</span>
                          <i *ngIf="billOfMaterialForm.get('finishedGoodItemID')?.value === product.itemID" class="bi bi-check2 text-success ms-2"></i>
                        </button>
                        <div *ngIf="filteredBomProducts.length === 0" class="p-2 text-muted small">
                          No matches
                        </div>
                        <div *ngIf="bomProductTotalPages > 1" class="d-flex justify-content-between align-items-center p-2 border-top bg-white">
                          <small class="text-muted">Page {{ bomProductCurrentPage }} of {{ bomProductTotalPages }}</small>
                          <nav aria-label="Products pagination">
                            <ul class="pagination pagination-sm mb-0">
                              <li class="page-item" [class.disabled]="bomProductCurrentPage === 1">
                                <button
                                  type="button"
                                  class="page-link"
                                  (click)="changeBomProductPage(bomProductCurrentPage - 1)"
                                  aria-label="Previous"
                                >
                                  <span aria-hidden="true">&laquo;</span>
                                </button>
                              </li>
                              <li
                                class="page-item"
                                *ngFor="let page of bomProductPages"
                                [class.active]="page === bomProductCurrentPage"
                              >
                                <button
                                  type="button"
                                  class="page-link"
                                  (click)="changeBomProductPage(page)"
                                >
                                  {{ page }}
                                </button>
                              </li>
                              <li class="page-item" [class.disabled]="bomProductCurrentPage === bomProductTotalPages">
                                <button
                                  type="button"
                                  class="page-link"
                                  (click)="changeBomProductPage(bomProductCurrentPage + 1)"
                                  aria-label="Next"
                                >
                                  <span aria-hidden="true">&raquo;</span>
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="productsWithoutBOMs.length == 0">
                      <div class="form-text small text-muted">
                        <i class="bi bi-info-circle me-1"></i> Only products without a BOM are shown
                      </div>
                    </ng-container>
                    <div class="invalid-feedback">Product is required</div>
                    <a *ngIf="!isEditMode" routerLink="/inventory" routerLinkActive="router-link-active" class="btn btn-sm btn-teal-gradient" style="margin-top: 10px; color: white;">
                      <i class="bi bi-plus-circle"></i> Add Product to Inventory
                    </a>
                  </ng-template>
                </div>

                <!-- <div class="col-md-6">
                  <label class="form-label">Description *</label>
                  <input type="text" class="form-control" formControlName="description"
                         [class.is-invalid]="billOfMaterialForm.get('description')?.invalid && billOfMaterialForm.get('description')?.touched" />
                  <div class="invalid-feedback">Description is required</div>
                </div> -->

                <div class="col-md-5">
                  <label class="form-check-label mb-2" for="isActive">Active</label>
                  <div class="form-check form-switch">
                    <input class="form-check-input form-switch" type="checkbox" id="isActive" formControlName="isActive">
                  </div>
                </div>
              </div>
            </div>

            <!-- Components section -->
            <div class="form-section item-section mb-2">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h6>Components</h6>
                <button type="button" class="btn btn-sm btn-teal-gradient" (click)="addComponent()">
                  <i class="bi bi-plus"></i> Add Component
                </button>
              </div>

              <div formArrayName="components" style="border-radius: 0.375rem; padding: 0.75rem;">
                <div *ngFor="let component of components.controls; let i = index" [formGroupName]="i" class="mb-3" style="  background: #fff;
                border-radius: 8px;
                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
                padding: 1.25rem;
                width: 100%;
                transition: transform 0.2s ease, box-shadow 0.2s ease;
                position: relative;
                overflow: hidden;">
                  <div class="card-body">
                    <div class="row g-4">
                      <div class="col-md-4 position-relative">
                        <label class="form-label" for="rawMaterialBtn_{{ i }}">Raw Material</label>
                        <!-- Toggler styled like a form-control -->
                        <button
                          type="button"
                          id="rawMaterialBtn_{{ i }}"
                          class="form-control text-start d-flex align-items-center justify-content-between"
                          [class.is-invalid]="component.get('rawMaterialItemID')?.invalid && component.get('rawMaterialItemID')?.touched"
                          #rawBtn
                          (mousedown)="onRawMaterialToggleMouseDown(i, rawBtn, $event)"
                          (click)="$event.stopPropagation()"
                          aria-haspopup="listbox"
                          [attr.aria-expanded]="rawMaterialDropdownOpenIndex === i"
                          [attr.aria-controls]="'rawMaterialMenu_' + i"
                        >
                          <span class="text-truncate">
                            {{ getRawMaterialDisplay(component.get('rawMaterialItemID')?.value) || 'Select Raw Material' }}
                          </span>
                          <i class="bi ms-2" [ngClass]="{ 'bi-chevron-down': rawMaterialDropdownOpenIndex !== i, 'bi-chevron-up': rawMaterialDropdownOpenIndex === i }"></i>
                        </button>

                        <!-- Custom dropdown menu -->
                        <div
                          class="card shadow-sm mt-1"
                          [id]="'rawMaterialMenu_' + i"
                          *ngIf="rawMaterialDropdownOpenIndex === i"
                          role="listbox"
                          (mousedown)="$event.stopPropagation()"
                          (click)="$event.stopPropagation()"
                          [ngStyle]="{
                            position: 'fixed',
                            zIndex: 2147483647,
                            top: (rawMaterialDropdownStyles[i] && rawMaterialDropdownStyles[i].top) || '0',
                            left: (rawMaterialDropdownStyles[i] && rawMaterialDropdownStyles[i].left) || '0',
                            width: rawMaterialDropdownStyles[i] ? 'calc(' + rawMaterialDropdownStyles[i].width + ' + 15%)' : '100%'
                          }"
                          style="border-radius: .375rem; max-height: 260px; overflow: hidden; pointer-events: auto;"
                        >
                          <div class="p-2 border-bottom bg-white">
                            <input
                              type="text"
                              class="form-control form-control-sm rm-search-input"
                              placeholder="Search raw materials..."
                              aria-label="Search raw materials"
                              [(ngModel)]="rawMaterialSearchText"
                              [ngModelOptions]="{ standalone: true }"
                              (ngModelChange)="onRawMaterialSearchChange()"
                              (keydown.escape)="rawMaterialDropdownOpenIndex = null"
                              autofocus
                            />
                          </div>
                          <div class="list-group list-group-flush" style="max-height: 210px; overflow-y: auto;">
                            <button type="button" class="list-group-item list-group-item-action" (click)="selectRawMaterial(i, { itemID: null })">
                              Select Raw Material
                            </button>
                            <button
                              type="button"
                              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                              *ngFor="let material of rawMaterialPaged"
                              (click)="selectRawMaterial(i, material)"
                              role="option"
                              [attr.aria-selected]="component.get('rawMaterialItemID')?.value === material.itemID"
                            >
                              <span class="text-truncate">{{ material.itemName }} - {{ getCategoryDisplayName(material.categoryID) }}</span>
                              <i *ngIf="component.get('rawMaterialItemID')?.value === material.itemID" class="bi bi-check2 text-success ms-2"></i>
                            </button>
                            <div *ngIf="filteredRawMaterials.length === 0" class="p-2 text-muted small">
                              No matches
                            </div>
                            <div *ngIf="rawMaterialTotalPages > 1" class="d-flex justify-content-between align-items-center p-2 border-top bg-white">
                              <small class="text-muted">Page {{ rawMaterialCurrentPage }} of {{ rawMaterialTotalPages }}</small>
                              <nav aria-label="Raw materials pagination">
                                <ul class="pagination pagination-sm mb-0">
                                  <li class="page-item" [class.disabled]="rawMaterialCurrentPage === 1">
                                    <button
                                      type="button"
                                      class="page-link"
                                      (click)="changeRawMaterialPage(rawMaterialCurrentPage - 1)"
                                      aria-label="Previous"
                                    >
                                      <span aria-hidden="true">&laquo;</span>
                                    </button>
                                  </li>
                                  <li
                                    class="page-item"
                                    *ngFor="let page of rawMaterialPages"
                                    [class.active]="page === rawMaterialCurrentPage"
                                  >
                                    <button
                                      type="button"
                                      class="page-link"
                                      (click)="changeRawMaterialPage(page)"
                                    >
                                      {{ page }}
                                    </button>
                                  </li>
                                  <li class="page-item" [class.disabled]="rawMaterialCurrentPage === rawMaterialTotalPages">
                                    <button
                                      type="button"
                                      class="page-link"
                                      (click)="changeRawMaterialPage(rawMaterialCurrentPage + 1)"
                                      aria-label="Next"
                                    >
                                      <span aria-hidden="true">&raquo;</span>
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            </div>
                          </div>
                        </div>

                        <div class="invalid-feedback">Raw material is required</div>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label">Quantity</label>
                        <input type="number" step="0.01" min="0.01" class="form-control" formControlName="quantityRequired"
                               [class.is-invalid]="component.get('quantityRequired')?.invalid && component.get('quantityRequired')?.touched" />
                        <div class="invalid-feedback">Must be greater than 0</div>
                      </div>

                      <div class="col-md-2">
                        <label class="form-label d-flex align-items-center gap-1">UOM
                          <app-tooltip [tooltipId]="'uom-manufacturing'">
                            <i icon class="bi bi-info-circle"></i>
                            <div content>
                              <p class="text-start">Tip: A unit of measure is a standard unit used to count or quantify something—like using meters (m) to measure length.</p>
                            </div>
                          </app-tooltip>
                        </label>
                        <ng-container *ngIf="component?.get('rawMaterialItemID')?.value; else noMaterial">
                          <select class="form-select" formControlName="componentUOMID"
                                  [class.is-invalid]="component.get('componentUOMID')?.invalid && component.get('componentUOMID')?.touched">
                            <option *ngFor="let uom of getUOMsForItem(component.get('rawMaterialItemID')?.value)"
                                    [value]="uom.uomid">
                              {{ uom.uomCode || uom.uomName }}
                            </option>
                          </select>
                          <div class="invalid-feedback">UOM is required</div>
                        </ng-container>
                        <ng-template #noMaterial>
                          <div class="form-control-plaintext">
                            <span class="text-muted">Select a raw material</span>
                          </div>
                        </ng-template>
                      </div>

                      <div class="col-md-1 d-flex align-items-end">
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeComponent(i)" [disabled]="components.length <= 1">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-grey-gradient" (click)="toggleAddModal()">Cancel</button>
            <button type="submit" class="btn btn-teal-gradient" [disabled]="loading || billOfMaterialForm.invalid">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ loading ? (isEditMode ? 'Updating...' : 'Saving...') : (isEditMode ? 'Update BOM' : 'Save BOM') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>


<!-- Sell Modal -->
<div *ngIf="showSellModal && order" class="modal-backdrop" (click)="showSellModal = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Sale
      </h2>
      <button type="button" class="close-button" (click)="showSellModal = false">x</button>
    </div>
    <div class="modal-body">
      <p> Are you sure you want to mark {{ quantityToSell }} units as sold for order {{ order.orderNumber }}?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showSellModal = false">Cancel</button>
      <button class="btn btn-danger" (click)="confirmSell()">Sell</button>
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="app-spinner-overlay">
  <div class="app-loading-spinner"></div>
</div>
